import React, { useState } from "react";
import "./ConfirmActionModal.css";

export default function ConfirmActionModal({
    isOpen,
    message = "Bạn có chắc chắn muốn thực hiện hành động này?",
    requireReason = true,
    onConfirm,
    onCancel
}) {
    const [reason, setReason] = useState("");

    if (!isOpen) return null;

    return (
        <div className="confirm-action-overlay" onClick={onCancel}>
            <div className="confirm-action-modal" onClick={(e) => e.stopPropagation()}>

                <div className="confirm-action-title">Thông báo</div>

                <div className="confirm-action-message">{message}</div>

                {requireReason && (
                    <input
                        className="confirm-action-input"
                        placeholder="Nhập lý do..."
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                    />
                )}

                <div className="confirm-action-buttons">
                    <button
                        className="confirm-action-btn-primary"
                        onClick={() => onConfirm(reason)}
                    >
                        Xác nhận
                    </button>

                    <button
                        className="confirm-action-btn-secondary"
                        onClick={onCancel}
                    >
                        Quay lại
                    </button>
                </div>

            </div>
        </div>
    );
}
